import React from 'react';

/**
 * HiTexProductsFooter
 * -------------------
 * Tiny, reusable strip that lists sister products from Hi Tex Lawn Pro LLC.
 * Drop into any public page's footer to build an "entity cluster" Google
 * recognizes across the two domains.
 *
 * Conventions:
 * - Rendered as a single unobtrusive line above the copyright row
 * - data-testid hooks included for testing
 * - Uses `rel="noopener"` (same-parent company, not a sponsored/affiliate link)
 */
export const HiTexProductsFooter = () => (
  <div
    className="w-full flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-xs text-muted-foreground/80"
    data-testid="hitex-products-footer"
  >
    <span>Another product from</span>
    <strong className="text-muted-foreground">Hi Tex Lawn Pro LLC</strong>
    <span aria-hidden="true">·</span>
    <a
      href="https://afincalc.com"
      target="_blank"
      rel="noopener"
      className="underline underline-offset-2 decoration-muted-foreground/40 hover:text-foreground hover:decoration-foreground transition-colors"
      data-testid="hitex-product-fincalc"
    >
      afincalc →
    </a>
  </div>
);

export default HiTexProductsFooter;
